import {
    Component,
    OnInit,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy,
    Output,
    EventEmitter,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { MatSort } from '@angular/material/sort';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UsersService, USER_ROLES } from 'app/pages/admin/users.service';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable, of, Subscription } from 'rxjs';
import { UiUtilsService } from 'app/shared/utils/ui-utils.service';
import { StatusCodeService } from 'app/shared/services/status-code.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerUser } from 'app/shared/models/customer-user';
import { DateutilService } from 'app/shared/services/dateutil.service';
import { SharedService } from 'app/shared/services/shared.service';
import { CustomerService } from 'app/shared/services/customer.service';
import { Locations } from 'app/shared/models/locations';
import { AdminUserData, GetPermissionsResponseUser, GetUsersResponse, User } from 'app/shared/models/users-permission';
import { USERS_FIRSTNAME_COLUMN, USERS_NAME_COLUMN, UsersDataDisplay, UsersInfo } from 'app/shared/models/users';
import {
    AppQueryParams,
    Customer,
    customerEditorQueryParam,
    customerQueryParam,
    userSearchPageIndexParam,
    userSearchPageSizeParam,
} from 'app/shared/models/customer';
import { AddLocationModalData } from 'app/shared/models/add-location';
import { DefaultResponse } from 'app/shared/models/default-response';
import { AddLocationComponent } from 'app/shared/components/map/add-location/add-location.component';
import { catchError, finalize, map, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { TrackBy } from 'app/shared/utils/track-by';
import { IComponentModalResult } from 'app/shared/models/modal';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerEditorPaginationState } from '../customer-editor-footer.model';
import { StringUtils } from 'app/shared/utils/string-utils';
@Component({
    selector: 'app-customer-detail-user-editor',
    templateUrl: './customer-detail-user-editor.component.html',
    styles: [],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDetailUserEditorComponent implements OnInit, OnDestroy {
    @Output() public usersSelected = new EventEmitter<boolean>();
    @Output() public paginationStateChange = new EventEmitter<CustomerEditorPaginationState>();
    public assignedRainGauge = new Array<Locations>();
    public isLoading: boolean;
    public loggedInUserRole: string;

    public customerDtlUserEdtrColumns = [
        'isSelected',
        'username',
        'userEmail',
        'name',
        'role',
        'lastLogin',
        'features',
        'isActive',
        'editLoc'
    ];
    public searchString = new FormControl();
    public users = new Array<User>();
    public initialUsersData = new Array<User>();
    private subscriptions = new Array<Subscription>();
    public userDataChange: BehaviorSubject<UsersDataDisplay[]> = new BehaviorSubject<UsersDataDisplay[]>([]);
    public userDataSource: MatTableDataSource<UsersDataDisplay> | null;
    public get userData(): UsersDataDisplay[] {
        return this.userDataChange.value;
    }
    public totalPaginationLength: number;
    private selectedCustomerId: number;
    private initialAssignedIds = new Set<string>();
    private toAdd = new Set<string>();
    private toRemove = new Set<string>();
    public isFetchingUser = false;
    public data: AdminUserData;
    public customerForUser: Customer[];
    public dismissBtnText: string;
    public updateSuccessfully: string;
    public customerAssociationUpdateFor: string;
    public customerAssociationUpdateFailed: string;
    public isRegisterUser: boolean;
    public addNewUserVisible: boolean;
    public isSaveEnabled = false;
    public isAllSelected = false;
    public customerEditedName: string;
    public isMatTableVisible = true;
    public viewAssigned: boolean;
    public dateFormat: string;
    public timeZone: string;
    public isIdexAccount?: boolean;

    @ViewChild(MatPaginator) public userPaginator: MatPaginator;
    @ViewChild(MatInput) public searchBox: MatInput;
    @ViewChild(MatSort) public userSort: MatSort;
    public userFilterColumns = ['username', 'userEmail', USERS_NAME_COLUMN, 'role', 'lastLogin', 'features', 'isActive'];

    public trackByIndex = TrackBy.byIndex;
    constructor(
        private translate: TranslateService,
        private dialog: MatDialog,
        private customerService: CustomerService,
        private usersService: UsersService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private sharedService: SharedService,
        private uiUtilsService: UiUtilsService,
        private snackBar: MatSnackBar,
        private router: Router,
        private dateUtilService: DateutilService,
        private statusCodeService: StatusCodeService,
    ) {
        /*  Search by user email address changes  */
        this.searchString.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(
            (res: string) => {
                this.filterUsers(res);
            },
            (error) => {
                // error block
            },
        );

        this.translate.get('COMMON.DISMISS_TEXT').subscribe((res: string) => {
            this.dismissBtnText = res;
        });

        this.translate.get('COMMON.IS_UPDATED_SUCCESSFULLY').subscribe((res: string) => {
            this.updateSuccessfully = res;
        });
        this.translate
            .get('ADMIN.CUSTOMER_USER_ASSOCIATION.UPDATE_CUSTOMER_ASSOCIATION_FOR')
            .subscribe((res: string) => {
                this.customerAssociationUpdateFor = res;
            });
        this.translate
            .get('ADMIN.CUSTOMER_USER_ASSOCIATION.CUSTOMER_ASSOCIATION_UPDATE_FAILED')
            .subscribe((res: string) => {
                this.customerAssociationUpdateFailed = res;
            });
    }

    public ngOnInit() {
        this.isLoading = true;
        this.usersService.isRegisterUserFeatureAllowed.subscribe(
            (response) => {
                this.isRegisterUser = response;
            },
            (error) => {
                // error block
            },
        );
        this.statusCodeService.userInfo.subscribe((result: UsersInfo) => {
            if (result) {
                this.loggedInUserRole = result.userRole.toString();
                this.isIdexAccount = result.isIdex;

                this.addNewUserVisible =
                    this.loggedInUserRole === USER_ROLES.ADMIN ||
                    this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN && this.isRegisterUser;
                    // #22179 have to rollback - all Customer Admins can create new users !
                    // (this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN && this.isRegisterUser && this.isIdexAccount);
            }
        });
        this.statusCodeService.customerIdInEditName.subscribe((customerName: string) => {
            this.customerEditedName = customerName;
        });

        // subscribe to route change
        const searchValue = this.searchString.value;
        let pageSize: number = this.userPaginator ? this.userPaginator.pageSize : 25;
        let pageIndex: number = this.userPaginator ? this.userPaginator.pageIndex : 0;

        this.subscriptions.push(
            combineLatest([this.dateUtilService.dateFormat, this.dateUtilService.timeFormat]).subscribe(
                ([newDateFormat, newTimeFormat]) => {
                    this.dateFormat =
                        this.dateUtilService.getStringFormat(newDateFormat) +
                        ' ' +
                        this.dateUtilService.getTimeFormat();
                },
            ),
        );

        this.activatedRoute.queryParamMap.subscribe(
            (params: ParamMap) => {
                this.selectedCustomerId = Number(params.get(customerEditorQueryParam));
                pageIndex = Number(params.get(userSearchPageIndexParam));
                pageSize = Number(params.get(userSearchPageSizeParam));

                if (this.selectedCustomerId) {
                    this.subscriptions.push(
                        combineLatest([
                            this.customerService.getCustomerById(this.selectedCustomerId),
                            this.customerService.getTimeZone(),
                        ]).subscribe(([res, timeZoneTypes]) => {
                            this.dateFormat =
                                this.dateUtilService.getStringFormat(res.dateFormat) +
                                ' ' +
                                this.dateUtilService.getTimeFormatFor(res.timeFormat);

                            const timeZoneType = timeZoneTypes.find((x) => x.value === res.timeZone);
                            this.timeZone = timeZoneType.utcValue;
                        }),
                    );
                } else {
                    this.subscriptions.push(
                        combineLatest([
                            this.dateUtilService.dateFormat,
                            this.dateUtilService.timeFormat,
                            this.dateUtilService.timeZone,
                            this.customerService.getTimeZone(),
                        ]).subscribe(([newDateFormat, newTimeFormat, newTimeZone, timeZoneTypes]) => {
                            this.dateFormat =
                                this.dateUtilService.getStringFormat(newDateFormat) +
                                ' ' +
                                this.dateUtilService.getTimeFormatFor(newTimeFormat);
                            const timeZoneType = timeZoneTypes.find((x) => x.value === newTimeZone);
                            this.timeZone = timeZoneType.utcValue;
                        }),
                    );
                }
            },
            (error) => {
                // error block
            },
        );
        if (!!searchValue) {
            this.searchString.setValue(searchValue);
        }
        this.loadInitialAssignedIdsAndUsers(pageSize, pageIndex);
    }
    public onChangeviewAssigned(): void {
        this.toAdd.clear();
        this.toRemove.clear();
        this.updateSaveEnabled();
        this.userPaginator.pageIndex = 0;
        this.userPaginator.pageSize = 25;
        this.loadUserList(25, 0);
    }
    public loadUserList(pageSize: number, pageIndex: number) {
        if (this.viewAssigned) {
            this.getAllActiveUsers(pageSize, pageIndex, this.searchString.value, true);
        } else {
            this.getUsers(pageSize, pageIndex, this.searchString.value, true);
        }
    }

    private loadInitialAssignedIdsAndUsers(pageSize: number, pageIndex: number): void {
        if (!this.selectedCustomerId) {
            this.loadUserList(pageSize, pageIndex);
            return;
        }
        const assignedIdsSubscription: Subscription = this.usersService
            .getAssignedUserIds(this.selectedCustomerId)
            .subscribe(
                (ids: Set<string>) => {
                    this.initialAssignedIds = ids;
                    this.loadUserList(pageSize, pageIndex);
                },
                (error) => {
                    // error block
                    this.loadUserList(pageSize, pageIndex);
                },
            );
        this.subscriptions.push(assignedIdsSubscription);
    }

    private isCheckedFor(userId: string, serverIsAssigned?: boolean): boolean {
        if (this.toRemove.has(userId)) {
            return false;
        }
        if (this.toAdd.has(userId)) {
            return true;
        }
        if (serverIsAssigned !== undefined) {
            return serverIsAssigned;
        }
        return this.initialAssignedIds.has(userId);
    }

    private updateAllSelectedFlag(): void {
        const selectableUsers = this.users.filter((user: User) => user.isActive);
        this.isAllSelected = selectableUsers.length > 0 && selectableUsers.every((user: User) => !!user.isSelected);
    }

    private updateSaveEnabled(): void {
        this.isSaveEnabled = this.toAdd.size > 0 || this.toRemove.size > 0;
        this.usersSelected.emit(this.isSaveEnabled);
    }
    public addNewLocation() {
        this.dialog
            .open<AddLocationComponent, AddLocationModalData, IComponentModalResult>(AddLocationComponent, {
                disableClose: true,
                data: {
                    rainGaugeLocations: this.assignedRainGauge,
                    customerId: this.selectedCustomerId,
                    isFromCustomerEditor: false
                },
            })
            .afterClosed()
            .subscribe((res) => {
                // to do after close
            });
    }

    private requestGetSort() {
        let sort: {value: string, direction: string} = null;
        if(this.userSort?.active) {
            sort = {
                value: this.userSort.active !== USERS_NAME_COLUMN ? this.userSort.active : USERS_FIRSTNAME_COLUMN,
                direction: this.userSort.direction
            };
        }

        return sort;
    }

    public getAllActiveUsers(pageSize: number, pageIndex: number, searchValue: string, redrawTable = true) {
        if (this.isFetchingUser) {
            return;
        }
        this.disableSearchBox();
        this.isFetchingUser = true;
        this.isLoading = true;

        const sort = this.requestGetSort();

        const allActiveUsersSubscription: Subscription = this.usersService
            .getAllUsers(pageSize, pageIndex + 1, searchValue, this.selectedCustomerId, undefined, undefined, undefined, sort)
            .subscribe(
                (response: GetUsersResponse) => {
                    if (response && response.payload && response.payload.length > 0) {
                        this.isMatTableVisible = true;
                        this.users = this.initialUsersData = response.payload;
                        this.totalPaginationLength = Math.round(response.count);
                        this.userPaginator.length = Math.round(response.count);
                        this.users.forEach((user: User) => {
                            user.isSelected = this.isCheckedFor(user.userID, true);
                        });
                    } else {
                        this.isMatTableVisible = false;
                        this.users = this.initialUsersData = [];
                        this.totalPaginationLength = 0;
                        this.userPaginator.length = 0;
                    }
                    if (redrawTable) {
                        this.generateUserTable(true);
                    }
                    this.isFetchingUser = this.isLoading = false;
                    this.emitPaginationState();
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.disableSearchBox(false);
                },
                () => {
                    this.isFetchingUser = this.isLoading = false;
                    this.emitPaginationState();
                    this.disableSearchBox(false);
                },
            );
        this.subscriptions.push(allActiveUsersSubscription);
    }

    public getUsers(pageSize: number, pageIndex: number, searchValue: string, redrawTable = true) {
        if (this.isFetchingUser) {
            return;
        }
        this.disableSearchBox();
        this.isFetchingUser = true;
        this.isLoading = true;

        const sort = this.requestGetSort();

        const customerusersSubscription: Subscription = this.usersService
            .getAllUsers(pageSize, pageIndex + 1, searchValue, null, undefined, undefined, undefined, sort)
            .subscribe(
                (response: GetUsersResponse) => {
                    if (response && response.payload && response.payload.length > 0) {
                        this.isMatTableVisible = true;
                        this.users = this.initialUsersData = response.payload;
                        this.totalPaginationLength = Math.round(response.count);
                        this.userPaginator.length = Math.round(response.count);
                        this.users.forEach((user: User) => {
                            user.isSelected = this.isCheckedFor(user.userID);
                        });
                    } else {
                        this.isMatTableVisible = false;
                        this.users = this.initialUsersData = [];
                        this.totalPaginationLength = 0;
                        this.userPaginator.length = 0;
                    }
                    if (redrawTable) {
                        this.generateUserTable(true);
                    }
                    this.isFetchingUser = this.isLoading = false;
                    this.emitPaginationState();
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.disableSearchBox(false);
                },
                () => {
                    this.isFetchingUser = this.isLoading = false;
                    this.emitPaginationState();
                    this.disableSearchBox(false);
                },
            );
        this.subscriptions.push(customerusersSubscription);
    }

    public toggleUserSelection(user: User, event: MatCheckboxChange) {
        const userId = user.userID;
        const wasInitiallyAssigned = this.initialAssignedIds.has(userId);

        if (event.checked) {
            this.toRemove.delete(userId);
            if (!wasInitiallyAssigned) {
                this.toAdd.add(userId);
            }
        } else {
            this.toAdd.delete(userId);
            if (wasInitiallyAssigned) {
                this.toRemove.add(userId);
            }
        }
        user.isSelected = event.checked;
        this.updateAllSelectedFlag();
        this.updateSaveEnabled();
    }

    public toggleAllDisplayedUsersSelection(event: MatCheckboxChange) {
        this.users.forEach((element: User) => {
            if (!element.isActive) {
                return;
            }
            const userId = element.userID;
            const wasInitiallyAssigned = this.initialAssignedIds.has(userId);
            element.isSelected = event.checked;

            if (event.checked) {
                this.toRemove.delete(userId);
                if (!wasInitiallyAssigned) {
                    this.toAdd.add(userId);
                }
            } else {
                this.toAdd.delete(userId);
                if (wasInitiallyAssigned) {
                    this.toRemove.add(userId);
                }
            }
        });
        this.updateSaveEnabled();
        this.generateUserTable(true);
    }

    /**
     * Method brings up a pop up window with user's name and customers menu
     * @param user the user data object.
     */

    public locationAssociation(user: User) {
        this.isLoading = true;
        const locationAssociation = this.usersService.getUserPermissions(user.userID).subscribe(
            (userData: GetPermissionsResponseUser) => {
                const userFullData = this.users.find((x) => x.userID === user.userID);
                this.customerForUser = userData.customers.map((x) => x.customer);
                if (user.userEmail === this.usersService.userName) {
                    const defaultCustomer = this.usersService.defaultCustomer.getValue();
                    userData.customers.forEach(
                        (customer) => {
                            if (defaultCustomer && customer.customer.customerID === defaultCustomer) {
                                customer.defaultCustomer = true;
                            } else {
                                customer.defaultCustomer = false;
                            }
                        },
                        (error) => {
                            // error block
                        },
                    );
                }
                // storing data in an object to send to the detail screen
                this.data = {
                    user: userData,
                    customers: this.customerForUser,
                };

                // setup the route for admin detail screen
                this.setupAdminDetailRoute(userFullData);
            },
            (error) => {
                // error block
            },
        );
        this.subscriptions.push(locationAssociation);
    }

    public setupAdminDetailRoute(userFullData: string | User) {
        const currentCustomerId = Number(this.activatedRoute.snapshot.queryParamMap.get(customerQueryParam));
        if (userFullData === '') {
            // Using Behaviour Subjects next method to emit the data
            this.sharedService.adminUserData.next(null);
        } else {
            const user = userFullData as User;
            sessionStorage.setItem('adsGuid', user.userID);
            this.data.user.userID = user.userID;
            // Using Behaviour Subjects next method to emit the data
            this.sharedService.adminUserData.next(this.data);
        }

        // get global query params
        const appQueryParams = <AppQueryParams>{
            c: currentCustomerId,
            cid: this.selectedCustomerId,
            lg: undefined,
            lt: undefined,
            u: userFullData === '' ? 'registeruser' : (userFullData as User).userEmail,
            s: !!this.searchString.value ? this.searchString.value : undefined,
            pi: !this.userPaginator.pageIndex ? 0 : Number(this.userPaginator.pageIndex),
            ps: this.userPaginator.pageSize || undefined,
        };

        // Navigating with required params

        this.isLoading = false;

        this.router.navigate(['/pages/admin/details'], {
            queryParams: appQueryParams,
            relativeTo: this.activatedRoute,
        });
    }
    /**
     * Method generates a table of users
     */
    public generateUserTable(enableServerSidePaging = false) {
        this.userDataSource = null;
        this.userDataChange = new BehaviorSubject<UsersDataDisplay[]>([]);
        this.users.forEach((user: User) => {
            const userCopiedData = this.userData.slice();
            const data = {
                userID: user.userID,
                userEmail: user.userEmail,
                firstName: user.firstName,
                lastName: user.lastName,
                username: user.userName,
                name: [user.firstName, user.lastName].join(' '),
                role: user.role,
                lastLogin: user.lastLogin ? new Date(user.lastLogin + 'Z') : '',
                locations: user.locations,
                customers: user.customers,
                features: user.features.sort(),
                isSelected: user.isSelected,
                isActive: user.isActive,
            };

            userCopiedData.push(data);
            this.userDataChange.next(userCopiedData);
        });
        this.updateAllSelectedFlag();
        this.userDataSource = new MatTableDataSource(this.userData);
    }

    public changePage(page: PageEvent): void {
        this.userPaginator.pageIndex = page.pageIndex;
        this.userPaginator.pageSize = page.pageSize;
        this.emitPaginationState();
        this.loadUserList(page.pageSize, page.pageIndex);
    }

    private emitPaginationState(): void {
        this.paginationStateChange.emit({
            length: this.totalPaginationLength ?? 0,
            pageIndex: this.userPaginator?.pageIndex ?? 0,
            pageSize: this.userPaginator?.pageSize ?? 25,
            pageSizeOptions: [10, 25, 100],
        });
    }

    public onDataSort() {
        const pageSize: number = this.userPaginator ? this.userPaginator.pageSize : 50;
        this.userPaginator.pageIndex = 0;
        this.loadUserList(pageSize, this.userPaginator.pageIndex)
    }


    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    /**
     * Method takes a sting as an argument and filters out users whose email addresses include the string
     * @param searchString - string to search for in email addresses
     */
    public filterUsers(searchString: string) {
        const pageSize: number = this.userPaginator.pageSize;
        this.userPaginator.pageIndex = 0;
        this.loadUserList(pageSize, this.userPaginator.pageIndex);
    }
    public disableSearchBox(isDisable = true) {
        if (this.searchBox) {
            this.searchBox.disabled = isDisable;
        }
    }
    public saveUserInformation(): void {
        this.isLoading = true;
        this.AssignUsers();
    }

    /**
     * Function to assign the users to a customer
     */

    public AssignUsers(): void {
        const createAssociationSubscription = this.savePendingChanges(true).subscribe();
        this.subscriptions.push(createAssociationSubscription);
    }

    public hasPendingChanges(): boolean {
        return this.isSaveEnabled;
    }

    public savePendingChanges(showSuccessNotification = true): Observable<boolean> {
        if (!this.hasPendingChanges()) {
            return of(true);
        }

        this.isLoading = true;
        const users = this.buildCustomerUserChanges();

        return this.usersService.assignUsers(this.selectedCustomerId, users).pipe(
            tap((res: Array<DefaultResponse>) => {
                if (res && res.length > 0) {
                    if (showSuccessNotification) {
                        this.showSnackBar(StringUtils.joinWithSingleSpace(this.customerEditedName, this.updateSuccessfully), true);
                    }
                    this.toAdd.forEach((id: string) => this.initialAssignedIds.add(id));
                    this.toRemove.forEach((id: string) => this.initialAssignedIds.delete(id));
                    this.toAdd.clear();
                    this.toRemove.clear();
                } else {
                    this.showSnackBar(`${this.customerAssociationUpdateFailed}`, false);
                }
                this.updateSaveEnabled();
                if (this.viewAssigned) {
                    this.userPaginator.pageSize = 25;
                    this.userPaginator.pageIndex = 0;
                    this.loadUserList(25, 0);
                }
            }),
            map((res: Array<DefaultResponse>) => !!res && res.length > 0),
            catchError(() => {
                this.updateSaveEnabled();
                this.showSnackBar(`${this.customerAssociationUpdateFailed}`, false);
                return of(false);
            }),
            finalize(() => {
                this.isLoading = false;
                this.uiUtilsService.safeChangeDetection(this.cdr);
            }),
        );
    }

    private buildCustomerUserChanges(): CustomerUser {
        const desiredAssigned = new Set<string>(this.initialAssignedIds);
        this.toAdd.forEach((id: string) => desiredAssigned.add(id));
        this.toRemove.forEach((id: string) => desiredAssigned.delete(id));

        return {
            addedUsers: Array.from(desiredAssigned),
            removedUsers: Array.from(this.toRemove),
        };
    }
    /**
     * Global function to handle all snackbar events
     */
    private showSnackBar(message: string, success: boolean) {
        const simpleSnackBarRef = this.snackBar.open(message, this.dismissBtnText);
        if(success) {
            setTimeout(simpleSnackBarRef.dismiss.bind(simpleSnackBarRef), 10000);
        }
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }
}

